export const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  dialogPaper: {
    minHeight: "400px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  boldFont: {
    fontWeight: 600,
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  table: {
    minWidth: 650,
    "& td:first-child": {
      position: "initial",
      left: "inherit"
    }
  },
  tableHeader: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid",
  },
  columnHeader: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid",
    width: "250px"
  },
  fieldName: {
    border: "1px solid #e0e0e0",
    borderTop: 0
  },
  fieldValue: {
    border: "1px solid #e0e0e0",
    borderTop: 0
  },
  radio: {
    color: '#E30613',
  },
  marginBottom2: {
    marginBottom: "2rem"
  },
  sectionTitle: {
    backgroundColor: "#e8e8e8",
    fontSize: "1rem",
    fontWeight: 600,
    padding: "0.5rem"
  },
  backgroundGrey: {
    backgroundColor: "#e8e8e8"
  },
  sectionButton: {
    padding: "9px"
  },
  contentDividerHeader: {
    borderLeft: "3px solid #e0e0e0 !important",
    backgroundColor: "#F7F7F7",
    width: "250px"
  },
  contentDividerCell: {
    borderLeft: "3px solid #e0e0e0 !important",
    borderTop: 0
  },
  actionColumnHeader: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid",
    width: "80px"
  },
  cardActionButton: {
    justifyContent: "flex-end",
  }
});